module.exports = __webpack_public_path__ + "img/check.db37de24.svg";